module.exports = __webpack_public_path__ + "img/calendar-star.aaa12bd.svg";